import {subjectGenus} from '../grammar';
import {Popup, popupDefaultCancelButton} from '../popup';
import {parsePlaceholders} from '../string';

export type ScheduleChooseActionType = 'modify' | 'cancel' | 'delete' | 'take' | 'assign' | 'move' | 'move-custom' | 'activate' | 'deactivate';

const chooseActions = {
    modify: {
        title: '%subjectNominativeSingular% ändern',
        textIcon: 'edit',
        text: '%articleNominativeSingular% %subjectNominativeSingular% <strong>%subjectTitle%</strong> besitzt eine Wiederholung. Möchten Sie die Änderung %articleGenitiveSingular% %subjectGenitiveSingular% für die gesamte Serie übernehmen oder nur %demonstrativePronounAccusative% %subjectNominativeSingular% anpassen?',
        buttonSingle: 'Nur %demonstrativePronounAccusative% %subjectNominativeSingular% ändern',
        buttonSerial: 'Ab %demonstrativePronounDative% %subjectNominativeSingular% ändern',
    },
    cancel: {
        title: '%subjectNominativeSingular% absagen',
        textIcon: 'event_busy',
        text: '%articleNominativeSingular% %subjectNominativeSingular% <strong>%subjectTitle%</strong> besitzt eine Wiederholung. Möchten Sie %articleDativeSingular% %subjectNominativeSingular% für die gesamte Serie absagen oder nur %demonstrativePronounDative% %subjectNominativeSingular%?',
        buttonSingle: 'Nur %demonstrativePronounDative% %subjectNominativeSingular% absagen',
        buttonSerial: 'Ab %demonstrativePronounDative% %subjectNominativeSingular% absagen',
    },
    delete: {
        title: '%subjectNominativeSingular% löschen',
        textIcon: 'delete',
        text: '%articleNominativeSingular% %subjectNominativeSingular% <strong>%subjectTitle%</strong> besitzt eine Wiederholung. Möchten Sie die gesamte Serie %articleGenitiveSingular% %subjectGenitiveSingular% oder nur %demonstrativePronounAccusative% %subjectNominativeSingular% löschen?',
        buttonSingle: 'Nur %demonstrativePronounAccusative% %subjectNominativeSingular% löschen',
        buttonSerial: 'Ab %demonstrativePronounDative% %subjectNominativeSingular% löschen',
    },
    activate: {
        title: '%subjectNominativeSingular% aktivieren',
        textIcon: 'check_circle',
        text: '%articleNominativeSingular% %subjectNominativeSingular% <strong>%subjectTitle%</strong> besitzt eine Wiederholung. Möchten Sie die gesamte Serie %articleGenitiveSingular% %subjectGenitiveSingular% oder nur %demonstrativePronounAccusative% %subjectNominativeSingular% aktivieren?',
        buttonSingle: 'Nur %demonstrativePronounAccusative% %subjectNominativeSingular% aktivieren',
        buttonSerial: 'Ab %demonstrativePronounDative% %subjectNominativeSingular% aktivieren',
    },
    deactivate: {
        title: '%subjectNominativeSingular% deaktivieren',
        textIcon: 'remove_circle',
        text: '%articleNominativeSingular% %subjectNominativeSingular% <strong>%subjectTitle%</strong> besitzt eine Wiederholung. Möchten Sie die gesamte Serie %articleGenitiveSingular% %subjectGenitiveSingular% oder nur %demonstrativePronounAccusative% %subjectNominativeSingular% deaktivieren?',
        buttonSingle: 'Nur %demonstrativePronounAccusative% %subjectNominativeSingular% deaktivieren',
        buttonSerial: 'Ab %demonstrativePronounDative% %subjectNominativeSingular% deaktivieren',
    },
    take: {
        title: '%subjectNominativeSingular% übernehmen',
        textIcon: 'redo',
        text: '%articleNominativeSingular% %subjectNominativeSingular% <strong>%subjectTitle%</strong> besitzt eine Wiederholung. Möchten Sie die gesamte Serie %articleGenitiveSingular% %subjectGenitiveSingular% oder nur %demonstrativePronounAccusative% %subjectNominativeSingular% übernehmen?',
        buttonSingle: 'Nur %demonstrativePronounAccusative% %subjectNominativeSingular% übernehmen',
        buttonSerial: 'Ab %demonstrativePronounDative% %subjectNominativeSingular% übernehmen',
    },
    assign: {
        title: '%subjectNominativeSingular% zuweisen',
        textIcon: 'call_made',
        text: '%articleNominativeSingular% %subjectNominativeSingular% <strong>%subjectTitle%</strong> besitzt eine Wiederholung. Möchten Sie die gesamte Serie %articleGenitiveSingular% %subjectGenitiveSingular% oder nur %demonstrativePronounAccusative% %subjectNominativeSingular% zuweisen?',
        buttonSingle: 'Nur %demonstrativePronounAccusative% %subjectNominativeSingular% zuweisen',
        buttonSerial: 'Ab %demonstrativePronounDative% %subjectNominativeSingular% zuweisen',
    },
    move: {
        title: '%subjectNominativeSingular% verschieben',
        textIcon: 'insert_invitation',
        text: '%articleNominativeSingular% %subjectNominativeSingular% <strong>%subjectTitle%</strong> besitzt eine Wiederholung. Möchten Sie die gesamte Serie %articleGenitiveSingular% %subjectGenitiveSingular% oder nur %demonstrativePronounAccusative% %subjectNominativeSingular% verschieben?',
        buttonSingle: 'Nur %demonstrativePronounAccusative% %subjectNominativeSingular% verschieben',
        buttonSerial: 'Ab %demonstrativePronounDative% %subjectNominativeSingular% verschieben',
    },
    'move-custom': {
        title: '%subjectNominativeSingular% verschieben',
        textIcon: 'insert_invitation',
        text: '%articleNominativeSingular% %subjectNominativeSingular% <strong>%subjectTitle%</strong> besitzt spezielle Wiederholungseinstellung. Möchten Sie %articleAccusativeSingular% %subjectGenitiveSingular% bearbeiten, um die Serie anzupassen, oder nur %demonstrativePronounAccusative% %subjectNominativeSingular% verschieben?',
        buttonSingle: 'Nur %demonstrativePronounAccusative% %subjectNominativeSingular% verschieben',
        buttonSerial: '%subjectNominativeSingular% bearbeiten',
    },
};

export default class Schedule
{
    static showChoosePopup(subjectTitle: string, action: ScheduleChooseActionType, genus: GenusType, subjectNominativeSingular: string, subjectGenitiveSingular: string): Promise<boolean>
    {
        const chooseAction = chooseActions[action];
        const placeholders = Object.assign(<object>subjectGenus[genus],
            {
                subjectNominativeSingular,
                subjectGenitiveSingular,
                subjectTitle,
            },
        ) as Record<string, string>;

        return new Promise((resolve, reject) =>
        {
            let popup = new Popup({
                title: parsePlaceholders(chooseAction.title, placeholders),
                titleIcon: 'repeat',
                text: parsePlaceholders(chooseAction.text, placeholders),
                textIcon: chooseAction.textIcon,
                textIconClass: 'text-grey',
                size: 'medium',
                buttons: [
                    {
                        type: popupDefaultCancelButton.type,
                        title: popupDefaultCancelButton.title,
                        icon: popupDefaultCancelButton.icon,
                        cmd(popup, event)
                        {
                            reject('popupClosed');
                            popup.close(event);
                        },
                    },
                    {
                        title: parsePlaceholders(chooseAction.buttonSingle, placeholders),
                        type: 'primary',
                        icon: 'radio_button_checked',
                        cmd(popup)
                        {
                            popup.close();
                            resolve(false);
                        },
                    },
                    {
                        title: parsePlaceholders(chooseAction.buttonSerial, placeholders),
                        icon: 'access_time',
                        type: 'secondary',
                        cmd(popup)
                        {
                            popup.close();
                            resolve(true);
                        },
                    },
                ],
            });

            popup.open();
        });
    }

    static get repeatSelectOptions(): SelectOption[]
    {
        return [
            {
                value: 'none',
                label: 'Keine Wiederholung',
            },
            {
                value: 'daily',
                label: 'Täglich',
            },
            {
                value: 'weekly',
                label: 'Wöchentlich',
            },
            {
                value: 'monthly',
                label: 'Monatlich',
            },
            {
                value: 'annually',
                label: 'Jährlich',
            },
        ];
    }

    static get weekSelectOptions(): SelectOption[]
    {
        return [
            {
                value: 0,
                label: 'Jeden',
            },
            {
                value: 1,
                label: 'Der erste',
            },
            {
                value: 2,
                label: 'Der zweite',
            },
            {
                value: 3,
                label: 'Der dritte',
            },
            {
                value: 4,
                label: 'Der vierte',
            },
            {
                value: 5,
                label: 'Der fünfte',
            },
            {
                value: 6,
                label: 'Der letzte',
            },
        ];
    }

    static get dayValues(): { name: string, number: number }[]
    {
        return [
            {
                number: 2,
                name: 'Mo',
            },
            {
                number: 3,
                name: 'Di',
            },
            {
                number: 4,
                name: 'Mi',
            },
            {
                number: 5,
                name: 'Do',
            },
            {
                number: 6,
                name: 'Fr',
            },
            {
                number: 7,
                name: 'Sa',
            },
            {
                number: 1,
                name: 'So',
            },
        ];
    }

    static get monthSelectOptions(): SelectOption[]
    {
        return [
            {
                value: 1,
                label: 'Januar',
            },
            {
                value: 2,
                label: 'Februar',
            },
            {
                value: 3,
                label: 'März',
            },
            {
                value: 4,
                label: 'April',
            },
            {
                value: 5,
                label: 'Mai',
            },
            {
                value: 6,
                label: 'Juni',
            },
            {
                value: 7,
                label: 'Juli',
            },
            {
                value: 8,
                label: 'August',
            },
            {
                value: 9,
                label: 'September',
            },
            {
                value: 10,
                label: 'Oktober',
            },
            {
                value: 11,
                label: 'November',
            },
            {
                value: 12,
                label: 'Dezember',
            },
        ];
    }

    static get monthDays(): { name: string, number: number }[][]
    {
        let days = [];
        for (let row of [0, 1, 2, 3, 4])
        {
            let rowDays = [];
            for (let day of [1, 2, 3, 4, 5, 6, 7])
            {
                let current = row * 7 + day;
                if (current <= 31)
                {
                    rowDays.push(
                        {
                            number: current,
                            name: ('0' + current).slice(-2),
                        },
                    );
                }
            }
            days.push(rowDays);
        }

        return days;
    }
}